import CustomError from "../CustomError";

export default class NotFoundException extends CustomError {}